import { useQuery } from '@tanstack/react-query'

import { settingServices } from '../settingServices'
import { FeaturesSettingsAdapterParams } from '../settingTypes'

import { QUERY_KEYS } from '@/constants/queryKeys'

interface QueryOptions {
  enabled?: boolean
}

export const useGetFeaturesSettings = (
  params?: FeaturesSettingsAdapterParams,
  queryOptions?: QueryOptions,
) =>
  useQuery({
    queryKey: [QUERY_KEYS.FEATURES_SETTINGS, params],
    queryFn: () => settingServices.getFeaturesSettings(params),
    staleTime: 60 * 60 * 1000,
    enabled: queryOptions ? queryOptions?.enabled : true,
  })
